<template>
<div class="chapter">
<div class="inner_page">
<p class="toc-head">Contents</p>
<p class="toc-front" id="copy-1"><span href="#/MontanaLegacy_copy" title="Link target outside of Sample">COPYRIGHT</span></p>
<p class="toc-front1" id="prol-1"><a href="#/MontanaLegacy_prol1">PROLOGUE</a></p>
<p class="toc-chapter" id="chap-1"><a href="#/MontanaLegacy_chap1">CHAPTER ONE</a></p>
<p class="toc-chapter" id="chap-2"><a href="#/MontanaLegacy_chap2">CHAPTER TWO</a></p>
<p class="toc-chapter" id="chap-3"><a href="#/MontanaLegacy_chap3">CHAPTER THREE</a></p>
<p class="toc-chapter" id="chap-4"><a href="#/MontanaLegacy_chap4">CHAPTER FOUR</a></p>
<p class="toc-chapter" id="chap-5"><a href="#/MontanaLegacy_chap5">CHAPTER FIVE</a></p>
<p class="toc-chapter" id="chap-6"><a href="#/MontanaLegacy_chap6">CHAPTER SIX</a></p>
<p class="toc-chapter" id="chap-7"><a href="#/MontanaLegacy_chap7">CHAPTER SEVEN</a></p>
<p class="toc-chapter" id="chap-8"><a href="#/MontanaLegacy_chap8">CHAPTER EIGHT</a></p>
<p class="toc-chapter" id="chap-9"><a href="#/MontanaLegacy_chap9">CHAPTER NINE</a></p>
<p class="toc-chapter" id="chap-10"><a href="#/MontanaLegacy_chap10">CHAPTER TEN</a></p>
<p class="toc-chapter" id="chap-11"><a href="#/MontanaLegacy_chap11">CHAPTER ELEVEN</a></p>
<p class="toc-chapter" id="chap-12"><a href="#/MontanaLegacy_chap12">CHAPTER TWELVE</a></p>
<p class="toc-chapter" id="chap-13"><a href="#/MontanaLegacy_chap13">CHAPTER THIRTEEN</a></p>
<p class="toc-chapter" id="chap-14"><a href="#/MontanaLegacy_chap14">CHAPTER FOURTEEN</a></p>
<p class="toc-chapter" id="chap-15"><a href="#/MontanaLegacy_chap15">CHAPTER FIFTEEN</a></p>
<p class="toc-chapter" id="chap-16"><a href="#/MontanaLegacy_chap16">CHAPTER SIXTEEN</a></p>
<p class="toc-chapter" id="chap-17"><a href="#/MontanaLegacy_chap17">CHAPTER SEVENTEEN</a></p>
<p class="toc-chapter" id="chap-18"><a href="#/MontanaLegacy_chap18">CHAPTER EIGHTEEN</a></p>
<p class="toc-chapter" id="chap-19"><a href="#/MontanaLegacy_chap19">CHAPTER NINETEEN</a></p>
<p class="toc-chapter" id="chap-20"><a href="#/MontanaLegacy_chap20">CHAPTER TWENTY</a></p>
<p class="toc-chapter" id="chap-21"><a href="#/MontanaLegacy_chap21">CHAPTER TWENTY-ONE</a></p>
<p class="toc-chapter" id="chap-22"><a href="#/MontanaLegacy_chap22">CHAPTER TWENTY-TWO</a></p>
<p class="toc-chapter" id="epil-1"><a href="#/MontanaLegacy_epil1">EPILOGUE</a></p>
<p class="toc-back1" id="teas-1"><a href="#/MontanaLegacy_teas1">A PREVIEW OF <em>MONTANA DESTINY</em></a></p>
<p class="toc-back" id="appe-1"><a href="#/MontanaLegacy_appe1">THE DISH</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// MontanaLegacy_toc.vue?6eab5f8d